import React from 'react';

export default function SkeletonLoader({ type = 'text', width, height, count = 1, className = '' }) {
    const renderSkeleton = () => {
        const items = [];

        for (let i = 0; i < count; i++) {
            let style = { width, height };
            let classes = `skeleton-item ${className}`;

            switch (type) {
                case 'text':
                    style = { width: width || '100%', height: height || '16px' };
                    break;
                case 'square':
                    classes += ' square';
                    style = { width: width || '56px', height: height || '56px' };
                    break;
                case 'circle':
                    classes += ' circle';
                    style = { width: width || '40px', height: height || '40px' };
                    break;
                case 'table-row':
                    // Specjalny case dla wierszy tabeli - zwrócimy inaczej
                    return renderTableRow();
                case 'orders-table':
                    return renderOrdersTable();
            }

            items.push(<div key={i} className={classes} style={style}></div>);
        }

        return <div className="skeleton-container">{items}</div>;
    };

    const renderTableRow = () => {
        // Tu będzie logika dla wierszy tabeli
        return <div>Table row skeleton</div>;
    };

    const renderOrdersTable = () => {
        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
            <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
            <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold', fontSize: '16px' }} colSpan="6">
            Moje zamówienia
            </th>
            </tr>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666', width: '120px' }}>
            Numer zamówienia
            </th>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
            Zamówione produkty
            </th>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666', width: '160px' }}>
            Data złożenia zamówienia
            </th>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666', width: '100px' }}>
            Wartość
            </th>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666', width: '120px' }}>
            Status
            </th>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', color: '#666', width: '80px' }}>
            Faktura
            </th>
            </tr>
            </thead>
            <tbody>
            {[1, 2, 3, 4, 5].map(i => (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px' }}>
                <SkeletonLoader type="text" width="40px" height="14px" />
                </td>
                <td style={{ padding: '12px' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                <SkeletonLoader type="square" />
                <SkeletonLoader type="square" />
                <SkeletonLoader type="square" />
                </div>
                </td>
                <td style={{ padding: '12px' }}>
                <SkeletonLoader type="text" width="120px" height="14px" />
                </td>
                <td style={{ padding: '12px' }}>
                <SkeletonLoader type="text" width="80px" height="14px" />
                </td>
                <td style={{ padding: '12px' }}>
                <SkeletonLoader type="text" width="100px" height="20px" />
                </td>
                <td style={{ padding: '12px', textAlign: 'center' }}>
                <SkeletonLoader type="text" width="30px" height="20px" />
                </td>
                </tr>
            ))}
            </tbody>
            </table>
        );
    };

    return renderSkeleton();
}
